import { sendRequest } from 'best-modules/vue-utils'
import { Plan, PlanCredentials } from '@/utils/types/plan'
import { Audit } from '@/utils/types/audit'
import { Query } from 'best-modules/utils'
import { PaginationList } from 'best-modules/components/server-table/types'

const planList = (query: Query): Promise<PaginationList<Plan>> => {
  return sendRequest({
    name: 'planList',
    method: 'get',
    url: {
      url: '/json/auditPlan',
      query,
    },
  })
}

const planCreate = (credentials: PlanCredentials): Promise<Plan> => {
  return sendRequest({
    name: 'planCreate',
    method: 'post',
    url: '/json/auditPlan',
    payload: credentials,
  })
}

const planUpdate = (
  planId: number,
  credentials: Omit<PlanCredentials, 'year'>
): Promise<Plan> => {
  return sendRequest({
    name: 'planUpdate',
    method: 'put',
    url: `/json/auditPlan/${planId}`,
    payload: credentials,
  })
}

const planSingle = (planId: number): Promise<Plan> => {
  return sendRequest({
    name: 'planSingle',
    method: 'get',
    url: `/json/auditPlan/${planId}`,
  })
}

const auditsByPlan = (planId: number): Promise<Audit[]> => {
  return sendRequest({
    name: 'planSingle',
    method: 'get',
    url: `/json/audit/byPlan/${planId}`,
  })
}

const auditsAddable = (query: Query): Promise<any> => {
  return sendRequest({
    name: 'auditsAddable',
    method: 'get',
    url: {
      url: '/json/audit/addable',
      query,
    },
  })
}

const attachAuditsToPlan = (
  planId: number,
  credentials: { auditIds: number[] }
): Promise<any> => {
  return sendRequest({
    name: 'attachAuditsToPlan',
    method: 'patch',
    url: `/json/auditPlan/attach/${planId}`,
    payload: credentials,
  })
}

const detachAuditsToPlan = (
  planId: number,
  credentials: { auditIds: number[] }
): Promise<any> => {
  return sendRequest({
    name: 'detachAuditsToPlan',
    method: 'patch',
    url: `/json/auditPlan/detach/${planId}`,
    payload: credentials,
  })
}

export {
  planList,
  planCreate,
  planUpdate,
  planSingle,
  auditsByPlan,
  auditsAddable,
  attachAuditsToPlan,
  detachAuditsToPlan,
}
